import styled from 'styled-components';

import { COLORS, BAR_COLORS } from '../../../../theme/tokens';
import { Panel } from '../../../../components/Panel';
import { Text } from '../../../../components/Text/Text';

/**
 * The Autopilot panel between the blog heading and the status tabs. A tighter
 * Panel than the list's: one row of words and a switch, not a table.
 */
export const Root = styled(Panel)`
  padding: 16px 20px;
`;

/** Words on the left, the switch on the right; wraps on a narrow viewport. */
export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Words = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1 1 320px;
`;

/** The Lumio mark and the feature name. */
export const TitleLine = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled(Text)`
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.text};
`;

/** The one line of copy: cadence and language, then the price. */
export const CopyLine = styled.div`
  font-size: 13px;
  line-height: 1.45;
  color: ${COLORS.textMuted};
`;

export const Copy = styled(Text)`
  font-size: 13px;
  line-height: 1.45;
  color: ${COLORS.textMuted};
`;

/** "Next article published around …": the live fact, in the body colour so it reads as one. */
export const NextLine = styled(Text)`
  font-size: 13px;
  line-height: 1.45;
  color: ${COLORS.text};
`;

/** The open credits notice: Autopilot is paused until a top-up. */
export const PausedLine = styled(Text)`
  font-size: 13px;
  line-height: 1.45;
  color: ${BAR_COLORS.warning};
`;

/**
 * Carries the disabled reason. A disabled switch takes no pointer events, so a
 * title on the switch itself would never surface as a tooltip; the wrapper's
 * does (same device as the page's `ActionReason`).
 */
export const ReasonWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

/** A paragraph of the confirmation dialog. */
export const ModalLine = styled(Text)`
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;
